import { render, staticRenderFns } from "./el-otherGroup.vue?vue&type=template&id=e4f9213a&scoped=true"
import script from "./el-otherGroup.vue?vue&type=script&lang=js"
export * from "./el-otherGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f9213a",
  null
  
)

export default component.exports